import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarRef,
  MatSnackBarVerticalPosition,
  SimpleSnackBar
} from '@angular/material/snack-bar';
import {LinkInfo, PersistentSnackBarComponent} from '../../shared/persistent-snack-bar/persistent-snack-bar.component';
import { SnackbarWithButtonComponent } from '../../shared/snack-bar-with-button/snackbar-with-button.component';


@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(
    private snackBar: MatSnackBar
  ) {}

  public openSnackBar(message: string, action?: string, duration = 2500, verticalPosition: MatSnackBarVerticalPosition = 'top'): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, action, {
      duration,
      panelClass: 'success-snackbar',
      verticalPosition
    });
  }

  public openErrorSnackBar(
    message: string,
    action?: string,
    duration = 5000,
    verticalPosition: MatSnackBarVerticalPosition = 'top'
  ): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, action, {
      duration,
      panelClass: 'error-snackbar',
      verticalPosition
    });
  }

  public openInfoSnackBar(message: string, action?: string, duration = 2500, verticalPosition: MatSnackBarVerticalPosition = 'top'):
    MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, action, {
      duration,
      panelClass: 'info-snackbar',
      verticalPosition
    });
  }

  public openPersistentSnackBar(message: string, panelClass: 'info-snackbar' | 'error-snackbar' | 'success-snackbar',
    verticalPosition: MatSnackBarVerticalPosition = 'top', linkInfo = null as LinkInfo): MatSnackBarRef<PersistentSnackBarComponent> {
    return this.snackBar.openFromComponent(PersistentSnackBarComponent, {
      data: {message, linkInfo},
      panelClass,
      verticalPosition
    });
  }

  public openSnackBarWithButton(message: string,
    verticalPosition: MatSnackBarVerticalPosition = 'top'): MatSnackBarRef<SnackbarWithButtonComponent> {
    return this.snackBar.openFromComponent(SnackbarWithButtonComponent, {
      data: {
        message
      },
      panelClass: 'action-snackbar',
      verticalPosition
    });
  }

  public dismiss() {
    this.snackBar.dismiss();
  }
}
